import $ from 'jquery';
import { TweenMax, TimelineLite } from 'gsap';
import { salvarTamanho } from './TamanhoSalvo';

$(document).ready(function() {
  let winWidth = $(window).width();

  var MOVE_MS = 500;

  var tCursor = {};
  tCursor.pos = -1;
  tCursor.isMoving = false;

  var tSetas = {};
  tSetas.elems = {};
  tSetas.elems.rightArrow = $('.tamanho-seta-direita');
  tSetas.elems.leftArrow = $('.tamanho-seta-esquerda');

  var tTabs = {};
  tTabs.elems = {};
  tTabs.elems.root = $('[data-tamanho-tabs]');
  tTabs.elems.tabs = tTabs.elems.root.find('[data-tamanho-set]');
  tTabs.elems.targets = tTabs.elems.root.find('.tamanho-target');
  tTabs.elems.slides = tTabs.elems.root.find('.tamanho-img');

  function enableSetas(esquerda, direita) {
    if(esquerda) {
      tSetas.elems.leftArrow.show();
    } else {
      tSetas.elems.leftArrow.hide();
    }

    if(direita) {
      tSetas.elems.rightArrow.show();
    } else {
      tSetas.elems.rightArrow.hide();
    }
  }

  function setTab(tamanho) {
    tTabs.elems.tabs.removeClass('active');
    tTabs.elems.root.find('[data-tamanho-set="'+tamanho+'"]').addClass('active');
    salvarTamanho(tamanho);
  }

  function setSlide(pos) {
    console.log('setSlide ', pos)
    if(tCursor.isMoving) return;
    if(pos <= 0) {
      enableSetas(false, true);
    } else if(pos >= tTabs.elems.slides.length - 1) {
      enableSetas(true, false);
    } else {
      enableSetas(true, true);
    }
    let activeSlide = tTabs.elems.root.find('.tamanho-img.current-slide');
    let activeIndex = activeSlide ? parseInt(activeSlide.data('tamanho-index')) : -1;
    let nextSlide = $(tTabs.elems.slides[pos]);
    if(!nextSlide.length) return;
    if(pos < 0 || pos > tTabs.elems.slides.length - 1) return;
    if(activeIndex === pos) return;
    tCursor.isMoving = true;
    setTab(nextSlide.data('tamanho'));
    if(activeIndex < pos) {
      console.log('entrou no if');
      // Some pra esquerda e vem o novo da direita
      TweenMax.to(activeSlide, MOVE_MS/1000, {
        left: -winWidth,
        opacity: 0,
        display: 'none',
      });
      TweenMax.fromTo(nextSlide, MOVE_MS/1000, {
        left: winWidth,
        opacity: 0,
        display: 'none',
      }, {
        left: 0,
        opacity: 1,
        display: 'block',
      });
    } else {
      console.log('entrou no else ', nextSlide);
      // Some pra direita e vem o novo da esquerda
      TweenMax.to(activeSlide, 1, {
        left: winWidth,
        opacity: 0,
        display: 'none',
      });
      TweenMax.fromTo(nextSlide, 1, {
        left: -winWidth,
        opacity: 0,
        display: 'none',
      }, {
        left: 0,
        opacity: 1,
        display: 'block',
      });
    }
    // Atualizar cursor
    tCursor.pos = pos;
    tTabs.elems.slides.removeClass('current-slide');
    nextSlide.addClass('current-slide');
    setTimeout(() => tCursor.isMoving = false, MOVE_MS);
  }

  function nextSlide() {
    console.log('nextSlide');
    setSlide(tCursor.pos+1);
  }

  function prevSlide() {
    console.log('prevSlide');
    setSlide(tCursor.pos-1);
  }

  // Bind click arrows
  tSetas.elems.leftArrow.on('click', () => prevSlide());
  tSetas.elems.rightArrow.on('click', () => nextSlide());

  // Setup slides
  tTabs.elems.slides.each(function(index) {
    let slide = $(this);
    slide.css({ 'background-image': "url('"+slide.data('img')+"')", opacity: 0, display: 'block' });
    slide.attr('data-tamanho-index', index);

    let mc = new Hammer(this);
    mc.get('pan').set({ threshold: 100, direction: Hammer.DIRECTION_HORIZONTAL });

    mc.on('panleft', () => nextSlide());
    mc.on('panright', () => prevSlide());
  });
  
  // Setup tabs
  tTabs.elems.tabs.click(function() {
    let tab = $(this);
    let tamanho = tab.data('tamanho-set');
    salvarTamanho(tamanho);
    tTabs.elems.tabs.removeClass('active');
    tab.addClass('active');

    let elTarget = $(tab.data('tamanho-tab'));
    let elTargetSlides = elTarget.find('[data-tamanho-index]');
    let firstIndex = parseInt($(elTargetSlides[0]).data('tamanho-index'));
    let lastIndex = parseInt($(elTargetSlides[elTargetSlides.length-1]).data('tamanho-index'));
    console.log('tab click ', tCursor.pos, firstIndex, lastIndex);
    if(tCursor.pos <= firstIndex) {
      setSlide(firstIndex);
    } else if(tCursor.pos >= lastIndex) {
      setSlide(lastIndex);
    }
  });
});
